import {Component, Input, OnInit} from '@angular/core';
import {Claim2CustomerI} from '../../../../../../interfaces/claim.interface';
import {Pager} from "../../../../../../interfaces/pager";
import {MatTableDataSource} from "@angular/material/table";
import {FormGroup} from "@angular/forms";
import {CustomerData, ExtendedScopeI} from "../../../../../../interfaces/customer-data";
import {PageEvent} from "@angular/material/paginator";
import {AppService} from "../../../../../../../../app.service";

@Component({
  selector: 'sta-tab-content',
  templateUrl: './tab-content.component.html',
  styleUrls: ['./tab-content.component.scss']
})
export class TabContentComponent implements OnInit {

  @Input() scope: ExtendedScopeI;
  @Input() c2cForm: FormGroup;
  @Input() customerData: CustomerData;

  //c2c pagination

  c2cDataSource = null;

  displayedColumns: string[] = [
    'claim_name',
  ];

  pager: Pager = {
    length: null,
    pageSize: 10,
    pageIndex: 0,
    sortCol: null,
    sortOrder: null
  };

  pageSizeOptions: number[] = [5, 10, 25, 100];

  // end c2c pagination

  constructor(private app: AppService) { }

  ngOnInit(): void {
    if(this?.scope.claims) {
      console.log(this.scope);
      this.pager.length = this.scope.total;
      this.c2cDataSource =  new MatTableDataSource(this.scope.claims);
    }
  }

  getClaimForm(c: Claim2CustomerI): FormGroup {
    const fg = this.c2cForm.get(c.external_claim_id) as FormGroup;
    return fg || null;
  }

  getClaimDesc(name: string) {
    const claim = this.customerData.all_claims.find(c => c.name === name);
    return claim ? claim.desc : 'Undefiniert';
  }

  privateClaim(c: Claim2CustomerI) {
    return c.external_customer_id.includes('@');
  }

  switchPage(e: PageEvent) {
    this.pager.pageIndex = e.pageIndex;
    this.pager.pageSize = e.pageSize;
    this.app.dialog.loader({
      title: 'Suche nach Benutzern'
    });
    this.app.customerClaims({input: this.customerData.customer.id, column: this.scope.name, pager: this.pager}).then(s => {
      this.app.dialog.closeLoader();
      if(s?.claims.length) {
        this.pager.length = s.total;
        this.c2cDataSource =  new MatTableDataSource(s.claims);
      }
    }).catch(e => {
      this.app.dialog.closeLoader();
    })
  }
}
